import { BaseService } from "mrb/core";
import { LoadioApiRouteService } from "common/services";

class LoadioService extends BaseService {
    constructor(apiClient) {
        super(apiClient, new LoadioApiRouteService());
    }

    updateMasterPassword(resource, abortSignal = null) {
        const url = this.routeService.updateMasterPassword(resource);
        return this.apiClient.put(url, resource, null, abortSignal);
    }
}

export default LoadioService;
